import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SigningFlowStepper } from './components';
import { useAuthorizationToken, useFlexFinalizeData } from './hooks';
function Layout({ children }) {
    const authorizationToken = useAuthorizationToken();
    const { finalizeData } = useFlexFinalizeData(authorizationToken);
    return (_jsx("div", { className: "flex-finalize-layout", children: _jsxs("div", { className: "flex-finalize-page", children: [_jsx(SigningFlowStepper, { downPaymentRequired: finalizeData?.downPaymentRequired }), children] }) }));
}
export default Layout;
